angular.module('iqxCore')
    .service('LanguageSvc', function() {
        var svc = this

        svc.lang = {
            ActionDialog: {
                createEvent: {
                    successMessage: "Contact Event Created Successfully."
                },
                createAppointment: {
                    successMessage: "Appointment/Reminder Created Successfully."
                },
                makecontact: 'Make Contact',
                viewdocuments: 'View Documents',
                logacontact: 'Log an Event',
                viewcontactlog: 'View Event Log',
                makeappontment: 'Make Appointment',
                ProgressHistory: "Progress History",
                favourites: {
                    add: 'Add to Favourites',
                    remove: 'Remove Favourite'
                }
            },
            PasswordComplexity: "This password is too weak. Please check your password against the required complexity.", // Password complexity message
            candidate: { // Candidate
                department: "Sector",
                details: "Details",
                bankdetails: "Bank Details",
                bankNonPAYETitle: "Sorry!",
                bankNonPAYEContent: "The bank details are managed by your agency, please contact your consultant to change them.",
                payslips: "Payslips",
                registration: "Registration",
                documents: "Documents",
                marketing: "Opt-in to Marketing Communications",
                timesheets: {
                    timesheets: "Timesheets",
                    current: "Current",
                    completed: "Completed"
                },
                diary: "Diary",
                diaryConfirmableShiftCaption: "Provisional Shift",
                diaryWorkingShiftCaption: "Working",
                diaryProvisionalShiftCaption: "Provisional Shift",
                diaryProvisionalShiftDescription: "'Confirmed by you. Awaiting confirmation from ",
                diaryCancelledShiftCaption: "Cancelled Shift",
                diaryAcceptShift: "I'm available",
                diaryDeclineShift: "I'm NOT available",
                diaryCloseShift: "Close",
                diaryDeleteShift: "Delete",
                diaryConfirmRejectShift: "Reject shift?",
                diaryConfirmDeleteAvailability: "Delete Availability?",
                jobsearch: "Jobs",
                jobsearchfind: "Search for a Job",
                jobsearchall: "All Jobs",
                jobsearchLogin: "Search for Jobs",
                payslipserror: "Please contact 'THE AGENCY' on '00000 000000' or use the 'Query' button beside the payslip to resolve this problem.",
                reports: "Reports",
                shifts: {
                    bookedStatus: {
                        you: "Successfully booked by you",
                        notAvailable: "You are no longer available",
                        someoneElse: "Booked by someone else"
                    }
                }
            }, // End Candidate

            client: { // Client
                details: "Contact Details",
                currentrequirements: "Current Requirements",
                timesheets: {
                    timesheets: "Timesheets",
                    current: "Current",
                    completed: "Completed",
                    awaitingauth: "Awaiting Authorisation",
                    awaitingappr: "Awaiting Approval"
                },
                contacts: "Contacts",
                invoices: "Invoices",
                invoiceNotFoundCustomError: "Please contact 'THE AGENCY' on '00000 000000' or use the 'Query' button beside the invoice to resolve this problem.",
                reports: "Reports"
            }, // End Client

            agency: { // Agency
                details: "Contact Details",
                candidates: "Candidates",
                timesheets: {
                    timesheets: "Timesheets",
                    current: "Current",
                    completed: "Completed"
                },
                contacts: "Contacts",
                reports: "Reports",
                jobs: "Jobs",
                requirements: "Current Opportunities"
            }, // End Agency

            owner: { // Owner
                stats: "Stats",
                api: "API",
                apihelp: "API Help",
                jobsearch: "Jobs",
                jobsearchfind: "Search for a Job",
                jobsearchall: "All Jobs",
                analytics: "IQX Analytics",
                reports: "Reports",
                test: "Test",
                favourites: "Favourites",
                consultantDiary: "Diary",
                requirements: "Current Requirements",
                search: {
                    search: "Search",
                    candidatesearch: "Candidates",
                    companysearch: "Companies",
                    contactsearch: "Contacts"
                },
                jobshortlist: "Your Shortlisted Jobs",
                documentCustomError: "Please contact 'THE AGENCY' on '00000 000000' to resolve this problem"
            }, // End Owner

            menu: { // Logged In Menu
                home: "Home",
                changepassword: "Change Password",
                loggedinas: "Logged in as",
                logout: "Logout",
            }, // End Logged In Menu

            pages: { // Individual Pages Language
                login: { // Login
                    username: "User Name",
                    password: "Password",
                    submit: "Login",
                    forgotpassword: "Forgotten your password?",
                    register: "Register",
                    or: "- OR -"
                }, // End Login

                payDocuments: { // Pay Documents
                    documentNotFound: {
                        title: 'Sorry, pay document not found.',
                        message: 'We cannot find any matching document, if you are sure your details are correct, please contact your payroll helpdesk.'
                    },
                    thanksForDownloading: {
                        title: 'Thanks.',
                        message: 'Your document should now have been downloaded.<br /><br />You may now close the window.'
                    }
                },

                wsop: { // WSOP
                    documentNotFound: {
                        title: 'Sorry, document not found.',
                        message: 'We cannot find any matching document, if you are sure your details are correct, please contact your helpdesk.'
                    },
                    thanksForDownloading: {
                        title: 'Thanks.',
                        message: 'Your document should now have been downloaded.<br /><br />You may now close the window.'
                    }
                },

                xRegister: { // xRegister
                    forenames: "Forenames",
                    surname: "Surname",
                    mobile: "Mobile",
                    dayPhone: "Day Phone",
                    dateOfBirth: "Date of Birth",
                    address: "Address",
                    address2: "",
                    address3: "",
                    email: "Email",
                    town: "Town",
                    county: "County",
                    country: "Country",
                    postcode: "Postcode",
                    niNumber: "NI Number",
                    utr: "Unique Tax Reference",
                    gender: "Gender (for Payroll)",
                    source: "How did you hear about us?",
                    validateYourEmailTitle: "Please validate your email.",
                    validateYourEmailBody: "You have been sent an email with a link, please click on this link to continue with registration.",
                    validateYourEmailFailureLine1: "Email validation failed, please try again",
                    validateYourEmailFailureLine2: "If it fails again, please contact us."

                }, // End xRegister

                resetpassword: { // Reset Password
                    info: "Please enter your registered email address to request a password reset",
                    infosent: "Thanks for your request.<br />If your email is registered you will receive a new password by email within 10 minutes.<br /><small>Remember to check your spam folder.</small>",
                }, // End Reset Password

                home: { // Home Page
                    welcome: "Welcome",
                }, // End Home Page

                candregister: { // Candidate Registration Page
                    buttoncaption: "Register",
                },

                registration: { // Department Registration
                    registration: "Registration",
                    edit: "Edit",
                    register: "Register",
                    selectone: "Select at least one to register",
                }, // End Department Registration

                documents: { // Documents
                    title: "Document to Upload",
                    information: {
                        line1: "Starred items must be entered before you can upload the document.",
                        line2: "Uploaded documents will be visible on the list below once internal processing is complete.",
                    },
                    table: {
                        type: "Type",
                        description: "Description",
                        lastupdate: "Last Updated",
                    }
                }, // End Department Registration

                timesheets: { // Timesheets
                    show_details: "Show Details",
                    current: {
                        title: "Current Timesheets",
                        completeandsendforapproval: "Complete and Send for Approval",
                        sendforapproval: "Send for Approval",
                        popupTitle: "Send for Approval",
                        fax: {
                            title: "Send to Fax",
                            info: "Your timesheet is completed, please enter a fax number to send for approval",
                            number: "Fax Number"
                        },
                        email: {
                            title: "Send to Email",
                            info: "Your timesheet is completed, please enter an email to send for approval.",
                            email: "Email Address"
                        },
                        table: {
                            date: "Date",
                            shiftdate: "Shift Date",
                            from: "From",
                            to: "To",
                            break: "Break",
                            breaks: "Breaks",
                            hours: "Hours",
                            total: "Total",
                            rate: "Rate",
                            paytype: "Pay Type",
                            unit: "Unit",
                            units: "Units",
                            expenses: "Expenses",
                            description: "Description",
                            shift: "Shift",
                            ref: "Ref.",
                        },
                    },
                    auth: {
                        title: "Timesheets for Authorisation",
                        authorise: "Authorise",
                        authorisation: "Authorisation",
                        disclaimer: "In authorising timesheets you are deemed to have read and accepted our terms of business. When a timesheet has been authorised you are deemed to have approved the resulting invoice and will not raise any objection in relation to our charges.",
                    },
                    appr: {
                        title: "Timesheets for Approval",
                        approve: "Approve",
                        approval: "Approval",
                    },
                    table: {
                        number: "Number",
                        client: "Client",
                        position: "Position",
                        enddate: "Week End Date",
                        temp: "Temp",
                        hours: "Hours",
                        total: "Total",
                    },
                    completed: {
                        table: {
                            date: "Date",
                            shiftdate: "Shift Date",
                            from: "From",
                            to: "To",
                            breaks: "Breaks",
                            break: "Break",
                            hours: "Hours",
                            total: "Total",
                            rate: "Rate",
                            paytype: "Pay Type",
                            unit: "Unit",
                            units: "Units",
                            expenses: "Expenses",
                        },
                    },
                    message: "Query",
                }, // End Timesheets

                diary: { // Diary
                    enteravailability: "Enter Availability",
                    key: "Key",
                    confirmOffer: "Confirm offer at ",
                    waitingOnClient: "Waiting on client at ",
                    confirmOfferKey: 'Accept or Reject the proposed shift.',
                    waitingOnClientKey: 'Awaiting confirmation from the client.',
                    workingAtKey: 'Confirmed Shift.',
                    workedAt: 'Worked Shift.',
                    availableKey: 'You are available.',
                    unAvailableKey: 'You are unavailable.',
                    holidayKey: 'You are on holiday.',
                    cancelledKey: 'Shift has been cancelled.',
                    bulkAddAvailability: 'Bulk Add Availability'
                }, // End Diary

                jobsearch: { // Job Search
                    title: "Job Search",
                    total: "Total Jobs Found",
                    apply: "Apply",
                    email: "Email",
                    hide: "Close",
                    reference: "Reference",
                    position: "Position",
                    jobtype: "Job Type",
                    department: "Department",
                    interviewdate: "Interview Date",
                    interviewtime: "Interview Time",
                    startdate: "Start Date",
                    finishdate: "Finish Date",
                    progress: "Progress State",
                    contact: "Agency Contact",
                    email: "Email",
                    dateapplied: "Date Applied"
                }, // End Job Search

                reports: { // Reports
                    title: "Reports",
                }, // End Reports
            }, // End Individual Pages Language
        }
    })